import { Component, OnInit } from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {ModalHelper} from '../../../../services/modalService/modal.helper';

export interface Model {
  title: string;
  data: string;
}

@Component({
  selector: 'app-open-sessions',
  templateUrl: './open-sessions.component.html',
  styleUrls: ['./open-sessions.component.css', '../../myreports.component.css']
})
export class OpenSessionsComponent extends DialogComponent<Model, any> implements OnInit {

  title: string;
  data: any;
  openSessions: any = [];
  totalSessions: number = 0;
  count: number = 0;
  currentUser: any;

  constructor(dialogService: DialogService,
              private modalHelper: ModalHelper) {
    super(dialogService);
  }

  ngOnInit() {
    this.openSessions = this.data.openSessions;
    this.totalSessions = this.data.totalSessions;
    this.count = this.data.count;
    this.currentUser = this.data.currentUser;
    document.getElementsByTagName('body')[0].classList.add('modal-open');
  }

    loginPrompt() {
        this.modalHelper.openLogin({});
    }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/open-sessions/open-sessions.component.ts